export default {
    listagem: {
        titulo_pagina: 'Lista de Componentes',
        novo: 'Criar novo Componente',
        habilitado: 'Habilitado',
        desabilitado: 'Desabilitado',
        table: {
            empty: 'Nenhum Componente encontrado',
            nome: 'Nome',
            codigo: 'Código',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Criar novo Componente',
            editar: 'Editar Componente'
        },
        fields: {
            codigo: {
                label: 'Código',
                description: 'Código do Componente'
            },
            nome: {
                label: 'Nome',
                description: 'Nome do Componente'
            },
            status: {
                label: 'Status',
                description: 'Status ativo ou inativo do Componente'
            },
            botao_salvar : 'Salvar Componente'
        },
        create: {
            success: 'Componente criado com Sucesso!',
            error: 'Error ao criar Componente!'
        },
        update: {
            success: 'Componente editado com Sucesso!',
            error: 'Error ao editar Componente!'
        }
    }
}
